import {PaymentBO} from "./PaymentBO";


export class PaymentBOValidations {

    static async Validate(aPmt: PaymentBO): Promise<void> {
        //--
    }

}